// extracted by mini-css-extract-plugin
export default {"pagination":"TablePaginationFooter_pagination__hF9Qk"};